<template>
    <div v-if="error" class="alert alert-danger" role="alert">
        {{ message }}
    </div>
    <div v-else class="alert alert-info" role="alert">
        <i class="fa fa-check-circle" aria-hidden="true"></i> {{ message }}
    </div>
</template>

<script>
    export default {
        name: 'Alert',
        props: {
            message: String,
            error: Boolean
        }
    }
</script>